import { useEffect, useState } from 'react';
import { DEFAULT_COIN_PAY_TYPE_FORM, ASSET_CLASS_OPTIONS, PAY_METHOD_KIND_OPTIONS, formToPayload, rowToForm } from './coinPayTypeConstants';

export default function CoinPayTypeEditModal({ open, row, onClose, onSubmit, submitting }) {
  const isEdit = Boolean(row?.id);
  const [form, setForm] = useState(DEFAULT_COIN_PAY_TYPE_FORM);
  const [error, setError] = useState('');

  useEffect(() => {
    if (open) {
      setForm(rowToForm(row));
      setError('');
    }
  }, [open, row?.id]);

  if (!open) {
    return null;
  }

  function updateField(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!form.code?.trim()) {
      setError('請填寫代碼');
      return;
    }
    if (!form.name?.trim()) {
      setError('請填寫名稱');
      return;
    }
    if (!form.currency?.trim()) {
      setError('請填寫幣別');
      return;
    }
    setError('');
    await onSubmit(formToPayload(form, row?.id));
  }

  return (
    <div className="admin-modal-overlay" role="presentation" onClick={onClose}>
      <div
        className="admin-modal admin-modal--wide"
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="admin-modal__header">
          <h3>{isEdit ? '編輯幣種' : '新增幣種'}</h3>
          <button type="button" className="admin-modal__close" onClick={onClose}>
            ×
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="admin-modal__body">
            <div className="form-grid">
              <div className="form-field">
                <label htmlFor="cptCode">代碼</label>
                <input
                  id="cptCode"
                  type="text"
                  value={form.code}
                  disabled={isEdit}
                  onChange={(e) => updateField('code', e.target.value)}
                  placeholder="如 usdt-trc20"
                />
              </div>
              <div className="form-field">
                <label htmlFor="cptName">名稱</label>
                <input
                  id="cptName"
                  type="text"
                  value={form.name}
                  onChange={(e) => updateField('name', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label htmlFor="cptCurrency">幣別</label>
                <input
                  id="cptCurrency"
                  type="text"
                  value={form.currency}
                  onChange={(e) => updateField('currency', e.target.value)}
                  placeholder="如 USDT、CNY"
                />
              </div>
              <div className="form-field">
                <label htmlFor="cptProtocol">協議</label>
                <input
                  id="cptProtocol"
                  type="text"
                  value={form.protocol}
                  onChange={(e) => updateField('protocol', e.target.value)}
                  placeholder="如 TRC20，可留空"
                />
              </div>
              <div className="form-field">
                <label htmlFor="cptAssetClass">資產大類</label>
                <select
                  id="cptAssetClass"
                  value={form.assetClass}
                  onChange={(e) => updateField('assetClass', e.target.value)}
                >
                  {ASSET_CLASS_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-field">
                <label htmlFor="cptPayMethodKind">支付方式</label>
                <select
                  id="cptPayMethodKind"
                  value={form.payMethodKind}
                  onChange={(e) => updateField('payMethodKind', e.target.value)}
                >
                  {PAY_METHOD_KIND_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-field">
                <label htmlFor="cptSort">排序</label>
                <input
                  id="cptSort"
                  type="number"
                  value={form.sort}
                  onChange={(e) => updateField('sort', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label htmlFor="cptImage">圖示 URL</label>
                <input
                  id="cptImage"
                  type="text"
                  value={form.image}
                  onChange={(e) => updateField('image', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label htmlFor="cptDepositRate">自定義充值匯率</label>
                <input
                  id="cptDepositRate"
                  type="number"
                  step="any"
                  value={form.customDepositRate}
                  onChange={(e) => updateField('customDepositRate', e.target.value)}
                />
              </div>
              <div className="form-field">
                <label htmlFor="cptWithdrawRate">自定義提現匯率</label>
                <input
                  id="cptWithdrawRate"
                  type="number"
                  step="any"
                  value={form.customWithdrawRate}
                  onChange={(e) => updateField('customWithdrawRate', e.target.value)}
                />
              </div>
            </div>

            {error && <div className="alert alert-error">{error}</div>}
          </div>
          <div className="admin-modal__footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={submitting}>
              取消
            </button>
            <button type="submit" className="btn btn-primary" disabled={submitting}>
              {submitting ? '保存中…' : '保存'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
